class CustomGridSlider extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

       $(this).css({ opacity: "1" });

        var autoplay = $(this).data("autoplay");
        var speed = Number($(this).data("speed")) || 2500;

        var swiper = new Swiper(".custom_media_slider-" + this.getAttribute("data-sectionid"), {
        spaceBetween: 10,
        loop: true,
        autoplay: autoplay
            ? {
                delay: speed,
                disableOnInteraction: false,
            }
            : false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        });
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-grid-swiper", CustomGridSlider);

class CustomTabCard extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var desktopperview = $(this).data('desktopperview');
        var mobileperview = $(this).data('mobileperview');
        var cardarticle = new Swiper(".custom-card-wrapper-info-"+ this.getAttribute("data-sectionid"), {
          spaceBetween: 14,
          slidesPerView: mobileperview,
          breakpoints: {
            0: {
              slidesPerView:mobileperview,
              spaceBetween: 14,
            },
            769:{
              slidesPerView:desktopperview,
              spaceBetween:30,
            }
          },
          pagination: {
            el: ".swiper-pagination",
          },
        });

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-tab-card", CustomTabCard);
